import createHttp from '@/config/http';
import type {
	GraftLogPayload,
	IUnassignedTissue,
	UnAssignedGraftsResponse,
} from '@/types/graftsToAssigned';
import type { ResponseMetaData } from '@/types/service';

// localhost:3003
const http = createHttp(import.meta.env.VITE_COMMON_URL);

export interface GraftsToAssignPayload {
	page?: number;
	limit?: number;
	columnsFilters?: string;
	search?: string;
	globalFilters?: string;
	sort?: string;
	port?: string
}

export const getGraftsToAssigned = async ({
	page = 1,
	limit = 15,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	port = ''
}: GraftsToAssignPayload): Promise<{
	items: IUnassignedTissue[];
	meta: ResponseMetaData;
}> => {
	const response = await http.post<UnAssignedGraftsResponse>(
		'/grafts-to-assign/all',
		{
			page: search !== '' ? 1 : page,
			limit,
			products: 'All',
			clinicProductData: '',
			filter: search,
			globalFilters,
			columnsFilters,
			sort,
			port
		},
	);

	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const newUnAssignedGraft = async (payload: GraftLogPayload) => {
	const response = await http.post(`/grafts-to-assign/create`, payload);
	return response.data;
};

export const updateUnAssignedGraft = async ({
	flag,
	payload,
}: {
	flag: number;
	payload: GraftLogPayload;
}) => {
	const response = await http.post(
		`/grafts-to-assign/update?flag=${flag}`,
		payload,
	);
	return response.data;
};

export const getUnAssignedTissueIds = async (clinics: string) => {
	const response = await http.get(
		`/grafts-to-assign/unassigned-tissues?clinics=${clinics}`,
	);
	return {
		items: response.data.data,
		meta: response.data.data.metaData,
	};
};
